import React, { useState } from 'react';
import AccessDenied from './AccessDenied';
import { base_url } from '../api/index';
import { useI18n } from '../i18n/I18nContext';
function EditCourierPopup({ courier, onSave, onClose }) {
    const { t } = useI18n();
    const [name, setName] = useState(courier.name);
    const [phone, setPhone] = useState(courier.phone);
    const [address, setAddress] = useState(courier.address);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [accessDenied, setAccessDenied] = useState(false);
    const handleSave = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${base_url}/couriers/${courier.id}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                  },
                body: JSON.stringify({ name, phone, address })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const updatedCourier = await response.json();
            onSave(updatedCourier);
        } catch (error: any) {
            if (error.response && error.response.status === 403 && error.response.data.message === "Forbidden") {
                setAccessDenied(true); // Set access denied if response status is 403
            } else {
               
                console.error('Error updating courier:', error);
                setError('Failed to update courier. Please try again later.');

                
            }
        } finally {
            setLoading(false);
        }
    };
    if (accessDenied) return <AccessDenied onClose={setAccessDenied}/>;
    return (
        <div className='max-w-mobile  fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-50'>
            <div className='bg-white p-6 rounded shadow-lg w-full max-w-lg'>
                <h4 className='font-semibold mb-3'>{t('modal.editCourier')}</h4>
                {error && <p className='text-red-500 mb-3'>{error}</p>}
                <div className='mb-3'>
                    <label className='block mb-1'>{t('courier.fullName')}</label>
                    <input
                        type='text'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className='border rounded w-full p-2'
                    />
                </div>
                <div className='mb-3'>
                    <label className='block mb-1'>{t('common.phone')}</label>
                    <input
                        type='text'
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        className='border rounded w-full p-2'
                    />
                </div>
                <div className='mb-3'>
                    <label className='block mb-1'>{t('courier.address')}</label>
                    <input
                        type='text'
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        className='border rounded w-full p-2'
                    />
                </div>
                <div className='flex justify-end gap-2'>
                    <button onClick={onClose} className='bg-gray-500 text-white py-1 px-3 rounded'>{t('common.close')}</button>
                    <button
                        onClick={handleSave}
                        className='bg-blue-500 text-white py-1 px-3 rounded'
                        disabled={loading}
                    >
                        {loading ? t('modal.updating') : t('courier.update')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EditCourierPopup;


